import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MedicinePriceHistory } from '@interfaces/medicine/medicine.interface';
import { MedicinesService } from '@services/medicines.service';
import { CallsService } from '@services/api/calls.service';
import { MedicinePriceHistoryEditDialogComponent } from '../medicine-price-history-edit-dialog/medicine-price-history-edit-dialog.component';

@Component({
  selector: 'app-medicine-price-history-dialog',
  templateUrl: './medicine-price-history-dialog.component.html',
})
export class MedicinePriceHistoryDialogComponent implements OnInit {
  public priceHistory: MedicinePriceHistory[] = [];
  public loading: boolean = true;
  public displayedColumns: string[] = ['fecha', 'laboratorio', 'distribuidor', 'pvl', 'descuento', 'recargo', 'pvln', 'actions'];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { medicineId: string },
    private dialogRef: MatDialogRef<MedicinePriceHistoryDialogComponent>,
    private medicinesService: MedicinesService,
    private callsService: CallsService,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    if (this.data.medicineId) {
      this.loadPriceHistory();
    }
  }

  loadPriceHistory(): void {
    this.loading = true;
    this.medicinesService.getMedicinePriceHistory(parseInt(this.data.medicineId)).subscribe({
      next: (priceHistory: MedicinePriceHistory[]) => {
        // Ordenar por fecha más reciente primero
        this.priceHistory = priceHistory.sort((a, b) => {
          const dateA = new Date(a.Fecha).getTime();
          const dateB = new Date(b.Fecha).getTime();
          return dateB - dateA; // Orden descendente (más reciente primero)
        });
        this.loading = false;
      },
      error: (error) => {
        console.error('Error loading price history:', error);
        this.loading = false;
      }
    });
  }

  onClose(): void {
    this.dialogRef.close();
  }

  formatDate(date: Date): string {
    if (!date) return '-';
    const d = new Date(date);
    const dateStr = d.toLocaleDateString('es-ES');
    const timeStr = d.toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit' });
    return `${dateStr} ${timeStr}`;
  }

  formatCurrency(value: number): string {
    if (value == null) return '-';
    return value.toFixed(2) + ' €';
  }

  formatPercentage(value: number): string {
    if (value == null) return '-';
    return value.toFixed(2) + ' %';
  }

  onEdit(priceHistoryItem: MedicinePriceHistory): void {
    const dialogRef = this.dialog.open(MedicinePriceHistoryEditDialogComponent, {
      data: { priceHistoryItem },
      width: '600px'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.savePriceHistory(result);
      }
    });
  }

  private savePriceHistory(data: { Id: number, DistribuidorId: number | null, LaboratorioId: number | null, PVL: number, Descuento: number, Recargo: number }): void {
    this.callsService.modifyClinicMedicinePriceHistory(data).subscribe({
      next: (response) => {
        if (response && response.payload) {
          this.callsService.openSnack('Precio actualizado correctamente');
          this.loadPriceHistory(); // Recargar la lista
        } else {
          this.callsService.openSnack('Error al actualizar el precio');
        }
      },
      error: (error) => {
        console.error('Error updating price history:', error);
        this.callsService.openSnack('Error al actualizar el precio');
      }
    });
  }
}
